"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Linked = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.Linked = function (props) {
    return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M1.925 4C1.925 2.7175 2.9675 1.675 4.25 1.675H7.25V0.25H4.25C2.18 0.25 0.5 1.93 0.5 4C0.5 6.07 2.18 7.75 4.25 7.75H7.25V6.325H4.25C2.9675 6.325 1.925 5.2825 1.925 4ZM5 4.75H11V3.25H5V4.75ZM11.75 0.25H8.75V1.675H11.75C13.0325 1.675 14.075 2.7175 14.075 4C14.075 5.2825 13.0325 6.325 11.75 6.325H8.75V7.75H11.75C13.82 7.75 15.5 6.07 15.5 4C15.5 1.93 13.82 0.25 11.75 0.25Z", fill: props.fill || common_styles_1.disabled })));
};
//# sourceMappingURL=linked.js.map